import classnames from 'classnames';
import React from 'react';
import { KEY_CODES } from '../../widget';
import styles from './content-slider.scss';
export class ContentSlider extends React.Component {
    constructor() {
        super(...arguments);
        // When navigation by tab, content can be scrolled by browser to show not visible focused elements
        // Used to move scroll back to initial state on blur not fully displayed last item at Lightbox
        this.preventScrollOnTab = (event) => {
            if (event.keyCode !== KEY_CODES.TAB || !this.containerRef.current) {
                return;
            }
            this.containerRef.current.scrollLeft = 0;
        };
        this.containerRef = React.createRef();
        this.contentRef = React.createRef();
        this.handleTransitionEnd = (event) => {
            if (event.target === this.contentRef.current) {
                if (this.props.onTransitionEnd !== undefined) {
                    this.props.onTransitionEnd();
                }
            }
        };
    }
    componentDidMount() {
        document.addEventListener('keydown', this.preventScrollOnTab);
    }
    componentWillUnmount() {
        document.removeEventListener('keydown', this.preventScrollOnTab);
    }
    getCurrentPageOffset() {
        const { currentPageNumber, width, isRTL } = this.props;
        const translateX = currentPageNumber * width * (isRTL ? 1 : -1);
        return {
            transform: `translate3d(${translateX}px, 0, 0)`,
        };
    }
    render() {
        const { children, disabled, className, dataHook, isRTL } = this.props;
        const contentStyles = classnames(styles.content, {
            [styles.disabled]: disabled,
            [styles.rtl]: isRTL,
            [styles.ltr]: !isRTL,
        });
        return (React.createElement("div", { "data-hook": dataHook, className: classnames(styles.container, className), ref: this.containerRef },
            React.createElement("div", { className: contentStyles, ref: this.contentRef, onTransitionEnd: this.handleTransitionEnd, "data-hook": "content-slider-content", style: this.getCurrentPageOffset() }, children)));
    }
}
//# sourceMappingURL=content-slider.js.map